import {useContext} from 'react'
import {ProductBadgesPageContext} from '../../context'
import ProductBadgesTableRow from './ProductBadgesTableRow'
import DynamicTable from '../../../../components/DynamicTable/DynamicTable'
import {PRODUCT_BADGES_TABLE_COLUMNS} from '../../utils'

const ProductBadgesTable = () => {
  const {productBadgesList, isLoading, onSortingChange, filters, hasWritePermission} =
    useContext(ProductBadgesPageContext)

  return (
    <DynamicTable
      id='kt_table_product_badges'
      data={productBadgesList}
      sortableColumns={PRODUCT_BADGES_TABLE_COLUMNS}
      TableRow={ProductBadgesTableRow}
      loading={isLoading}
      filters={filters}
      onSortingChange={onSortingChange}
      tableClass='table-row-dashed table-row-gray-300 align-middle gs-0 gy-2 mb-15'
      tableHeaderClass='table-row-bordered'
      hasPermission={hasWritePermission}
    />
  )
}

export default ProductBadgesTable
